export const USER_CATEGORY = {
  VENDOR: 1,
  STAFF: 2,
};

export const PROCUREMENT_TYPE = {
  Asset: 0,
  Consummable: 1,
  Consummable_Type: {
    Goods: "goods",
    Services: "service",
  },
};

export const ONBOARDING_STAGES = {
  PERSONAL_DETAILS: 1,
  CONTACT_DETAILS: 2,
  INSURANCE_DETAILS: 3,
  BUSINESS_DOCUMENTS: 4,
  REVIEW: 5,
  ALL_DONE: 6,
  SUCCESS: 7,
};
